import React from 'react';
import { StatCardData } from '../../types';
import BackgroundImage from './BackgroundImage';
import styles from '../../styles/components/ui/stat-card.module.css';

interface StatCardProps {
  data: StatCardData;
}

const StatCard: React.FC<StatCardProps> = ({ data }) => {
  const formatNumber = (num: number): string => {
    return num.toLocaleString();
  };

  return (
    <BackgroundImage
      src={require('../../assets/images/stats/stat-card-bg.png')}
      className={styles.statCard}
      alt={data.label}
    >
      <div className={styles.statContent}>
        <div className={styles.statNumber}>
          {formatNumber(data.count)}{data.unit}
        </div>
        <div className={styles.statLabel}>
          {data.label}
        </div>
      </div>
    </BackgroundImage>
  );
};

export default StatCard;